<template>
    <v-container fluid>
        <v-row v-show="populating == false && populatingFailure == false">
            <v-col
                    cols="12"
                    md="6"
            >
                <v-card>
                    <v-form ref="brokerfirmForm"
                            v-model="isValid">
                        <v-card-text>
                            <v-container class="pb-0"
                                         fluid>
                                <v-row class="pb-0">
                                    <v-col cols="12">
                                        <v-text-field :disabled="isLoading"
                                                      :rules="[requiredRule, lengthRule(50)]"
                                                      label="Name"
                                                      v-model="brokerfirm.name"/>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-select
                                                :disabled="isLoading"
                                                :items="brokerFirmStatuses"
                                                item-text="value"
                                                item-value="key"
                                                label="Broker Firm Status"
                                                v-model="brokerfirm.brokerFirmStatus"
                                        ></v-select>
                                    </v-col>
                                </v-row>
                                <v-row align="end"
                                       class="pt-0"
                                       justify="space-between"
                                       no-gutters>
                                    <v-btn :disabled="isLoading && !isDeleting"
                                           :loading="isDeleting"
                                           @click="deleteEntity"
                                           class="text-none"
                                           color="warning darken-1"
                                           text
                                           v-show="brokerfirm.id > 0">
                                        Delete
                                    </v-btn>
                                    <v-spacer/>
                                    <v-btn :disabled="isLoading && !isSaving"
                                           :loading="isSaving"
                                           @click="saveEntity"
                                           class="text-none"
                                           color="secondary darken-1"
                                           text>
                                        {{ brokerfirm.id > 0 ? "Update" : "Add" }}
                                    </v-btn>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-form>
                    <v-snackbar :color="notifyColor"
                                :timeout="15000"
                                top
                                v-model="notifyShow">
                        {{ notifyMessage }}
                        <template v-slot:action="{ attrs }">
                            <v-btn @click="notifyShow = false"
                                   class="text-none"
                                   icon
                                   v-bind="attrs">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                    </v-snackbar>
                </v-card>
            </v-col>
            <v-col cols="12"
                   md="6"
                   no-gutters>
                <BrokerFirmNotesList :broker-firm-id="brokerfirmId"/>
                <br/>
                <BrokerFirmContactsList :broker-firm-id="brokerfirmId"/>
            </v-col>
        </v-row>
        <v-row v-show="populating === true">
            <v-col class="text-center"
                   cols="12">
                <v-progress-circular :size="50"
                                     color="secondary"
                                     indeterminate/>
            </v-col>
        </v-row>
        <v-row v-show="populating === false && populatingFailure === true">
            <v-col class="text-center"
                   cols="12">
                Could not load the form. Please refresh the page and try again.
                If the issue persists contact support.
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import BrokerFirm from "../../models/BrokerFirm.model";
import uuid4 from "../../helpers/uuid4";
import BrokerFirmNotesList from "@/components/widgets/BrokerFirmNotes/BrokerFirmNotesList.vue";
import BrokerFirmContactsList from "@/components/widgets/BrokerFirmContacts/BrokerFirmContactsList.vue";
import brokerfirmService from "@/services/brokerfirm.service";

export default {
    props: {
        brokerfirmId: {
            type: Number,
            default: 0
        },
    },
    components: {
        BrokerFirmContactsList,
        BrokerFirmNotesList
        //
    },
    async mounted() {
        await this.load();
        this.loadBrokerFirmStatuses();
    },
    data() {
        return {
            brokerfirmIdValue: this.brokerfirmId,
            populating: true,
            populatingFailure: true,
            requestId: uuid4(),
            brokerfirm: {},
            brokerfirmIn: {},
            isValid: null,
            isLoading: null,
            isSaving: null,
            isDeleting: null,
            notifyShow: null,
            notifyMessage: null,
            notifyColor: null,
            requiredRule: v => !!v || "required",
            lengthRule: limit => v =>
                !v || v.length <= limit || "exceeds " + limit + " characters",
            emailRule: v => /.+@.+$/.test(v) || "invalid email",
            contract: null,

            newNoteShow: null,
            newNoteAdding: false,
            newNoteText: "",
            brokerFirmStatuses: []
        };
    },
    computed: {
        //
    },
    methods: {
        async load() {
            this.populating = true;
            this.populatingFailure = true;

            if (this.brokerfirmIdValue > 0) {
                var requestId = (this.requestId = uuid4());
                var brokerfirmResponse = await this.$store.dispatch(
                    "brokerfirms/get",
                    {
                        id: this.brokerfirmIdValue,
                        urlParameters: {},
                        requestId: requestId
                    }
                );
                if (this.requestId === brokerfirmResponse.requestId &&
                    brokerfirmResponse.data.total === 1 &&
                    brokerfirmResponse.data.page[0].id === this.brokerfirmIdValue
                ) {
                    this.brokerfirmIn = brokerfirmResponse.data.page[0];
                    this.brokerfirm = new BrokerFirm().set(this.brokerfirmIn);
                    this.populatingFailure = false;
                }
            } else if (this.brokerfirmIdValue === 0) {
                this.brokerfirm = new BrokerFirm();
                this.populatingFailure = false;
            }
            this.populating = false;
        },

        //emitters      ------------------------------------------------------------
        emitSavedEntity(savedBrokerFirm) {
            this.$emit("saved", savedBrokerFirm);
        },
        emitDeletedEntity(deletedBrokerFirm) {
            this.$emit("deleted", deletedBrokerFirm);
        },
        emitCloseForm() {
            this.$emit("close");
        },
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        closeForm() {
            this.notifyShow = false;
            this.emitCloseForm();
        },
        validateForm() {
            this.isValid = this.$refs.brokerfirmForm.validate();
            return this.isValid;
            /*
            if (!(this.brokerfirm.driverIdentityId > 0))
                this.brokerfirm.driverIdentityId = 0;

            if (this.isValid) return this.brokerfirm.driverIdentityId > 0;
            else return false;
            */
        },

        //save      ------------------------------------------------------------
        async saveEntity() {
            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;

                var formdata = new FormData();
                //formdata.append("somefile", this.somefile);
                formdata.append("Model", JSON.stringify(this.brokerfirm));

                const parameters = {
                    id: this.brokerfirm.id,
                    formData: formdata
                };
                var hasId = this.brokerfirm.id > 0;
                try {
                    var brokerfirm = await this.$store.dispatch(
                        "brokerfirms/" + (hasId ? "update" : "create"),
                        hasId ? parameters : parameters.formData
                    );
                    this.notify("BrokerFirm successfully saved.", "success");
                    if (!(this.brokerfirm.id > 0)) {
                        this.brokerfirm.id = brokerfirm.id;
                        this.brokerfirmIdValue = this.brokerfirm.id;
                    }
                    this.emitSavedEntity(brokerfirm);
                    await this.load();
                } catch (e) {
                    this.notify(e.response.data, "error");
                }
                this.saveEntityDone();
            }
        },
        saveEntityDone() {
            this.isLoading = false;
            this.isSaving = false;
        },
        //delete        ------------------------------------------------------------
        deleteEntity() {
            var isConfirmed = confirm(
                "Are you sure you want to delete this Broker Firm?"
            );
            if (isConfirmed) {
                this.isLoading = true;
                this.isDeleting = true;
                this.$store
                    .dispatch("brokerfirms/delete", this.brokerfirm.id)
                    .then(
                        () => {
                            this.notify(
                                "Broker Firm successfully deleted.",
                                "success"
                            );
                            this.emitDeletedEntity(this.brokerfirm);
                            this.closeForm();
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.deleteEntityDone);
            }
        },
        deleteEntityDone() {
            this.isLoading = false;
            this.isDeleting = false;
        },
        async loadBrokerFirmStatuses() {
            this.brokerFirmStatuses = await brokerfirmService.getBrokerFirmStatuses();
        }
    }
};
</script>

<style lang="stylus" scoped></style>
